import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/ActionMenu"
      }}>{`ActionMenu`}</a>{` instead.`}</p>
    <hr></hr>
    <p>{`The Dropdown component is a lightweight context menu for housing navigation and actions.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`Dropdown.Button`}</inlineCode>{` as the trigger for the dropdown, or use a custom `}<inlineCode parentName="p">{`summary`}</inlineCode>{` element if you would like. `}<strong parentName="p">{`You must use a `}<inlineCode parentName="strong">{`summary`}</inlineCode>{` tag in order for the dropdown to behave properly!`}</strong>{`. You should also add `}<inlineCode parentName="p">{`aria-haspopup="true"`}</inlineCode>{` to custom dropdown triggers for accessibility purposes. You can use the `}<inlineCode parentName="p">{`Dropdown.Caret`}</inlineCode>{` component to add a caret to a custom dropdown trigger.`}</p>
    <p>{`Dropdown.Menu wraps your menu content. Be sure to pass a `}<inlineCode parentName="p">{`direction`}</inlineCode>{` prop to this component to position the menu in relation to the Dropdown.Button.`}</p>
    <h2>{`Default example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<Dropdown>
  <Dropdown.Button>Dropdown</Dropdown.Button>
  <Dropdown.Menu direction="sw">
    <Dropdown.Item>Item 1</Dropdown.Item>
    <Dropdown.Item>Item 2</Dropdown.Item>
    <Dropdown.Item>Item 3</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
`}</code></pre>
    <h2>{`With custom button`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<Dropdown>
  <summary>
    Dropdown
    <Dropdown.Caret />
  </summary>
  <Dropdown.Menu direction="sw">
    <Dropdown.Item>Item 1</Dropdown.Item>
    <Dropdown.Item>Item 2</Dropdown.Item>
    <Dropdown.Item>Item 3</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <p>{`The Dropdown component is extended from the `}<a parentName="p" {...{
        "href": "/Details"
      }}><inlineCode parentName="a">{`Details`}</inlineCode></a>{` component and gets all props that the `}<a parentName="p" {...{
        "href": "/Details"
      }}><inlineCode parentName="a">{`Details`}</inlineCode></a>{` component gets.`}</p>
    <h3>{`Dropdown.Menu`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`direction`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`'sw'`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the direction of the dropdown menu. Pick from 'ne', 'e', 'se', 's', 'sw', or 'w'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sx`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`SystemStyleObject`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`{}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Style to be applied to the component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Dropdown.Button`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://primer.style/react/Buttons#component-props"
      }}>{`https://primer.style/react/Buttons#component-props`}</a></p>
    <h3>{`Dropdown.Caret`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sx`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`SystemStyleObject`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`{}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Style to be applied to the component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Dropdown.Item`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sx`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`SystemStyleObject`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`{}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Style to be applied to the component`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      